import { UserDetailsPage } from 'features/users';

export const AdminUserDetailsPage: React.FC = () => <UserDetailsPage />;
